// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "7070a7c483fb774beb4d242608d6f39c99d341e1/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","41":"a0ec33ed","777":"dfb468f1","788":"c61fe626","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};